import { render, staticRenderFns } from "./ContactTypeEdit.vue?vue&type=template&id=3810426e"
import script from "./ContactTypeEdit.vue?vue&type=script&lang=js"
export * from "./ContactTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports